import { Button } from "@/components/ui/button";
import { ChevronDown, PanelLeft, SquarePen } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { assistantIconButtonClassName } from "./assistantClasses";

interface AssistantHeaderProps {
    canStartNew: boolean;
    isResetting: boolean;
    onNewConversation: () => void;
    onClose: () => void;
    onShowHistory?: () => void;
    outline?: ReactNode;
}

const AssistantHeader = ({
    canStartNew,
    isResetting,
    onNewConversation,
    onClose,
    onShowHistory,
    outline,
}: AssistantHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="pointer-events-none absolute inset-x-0 top-0 z-10 flex items-center justify-between gap-3 p-3">
            <div className="pointer-events-auto flex min-w-0 items-center gap-2">
                {onShowHistory && (
                    <Button
                        aria-label={t("vistassistant.history.title")}
                        aria-pressed={false}
                        className={assistantIconButtonClassName}
                        onClick={onShowHistory}
                        title={t("vistassistant.history.title")}
                        variant="ghost"
                    >
                        <PanelLeft strokeWidth={1.5} />
                    </Button>
                )}
            </div>
            <div className="pointer-events-auto flex flex-none items-center gap-0.5">
                {outline && <div className="md:hidden">{outline}</div>}
                {canStartNew && (
                    <Button
                        aria-label={t("vistassistant.newConversation")}
                        className={assistantIconButtonClassName}
                        disabled={isResetting}
                        onClick={onNewConversation}
                        title={t("vistassistant.newConversation")}
                        variant="ghost"
                    >
                        <SquarePen strokeWidth={1.5} />
                    </Button>
                )}
                <Button
                    aria-label={t("vistassistant.closeAssistant")}
                    className={assistantIconButtonClassName}
                    onClick={onClose}
                    title={t("vistassistant.closeAssistant")}
                    variant="ghost"
                >
                    <ChevronDown strokeWidth={1.5} />
                </Button>
            </div>
        </div>
    );
};

export default AssistantHeader;
